import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const ClientTimezoneContext = createContext("");
export const ClientTimezoneContextProvider = ({ children }) => {
    const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return _jsx(ClientTimezoneContext.Provider, { value: clientTimezone, children: children });
};
export const useClientTimezone = () => {
    const context = useContext(ClientTimezoneContext);
    if (context === "" || context === undefined) {
        throw new Error("useClientTimezone must be used within a ClientTimezoneContextProvider");
    }
    return context;
};
//# sourceMappingURL=ClientTimezone.js.map